import {FC, useEffect, useMemo} from 'react';
import {toast} from 'react-toastify';
//mui
import {Box, SelectChangeEvent} from '@mui/material';
//store
import {
  getCurrentEventSelector,
  getEvent,
  getEvents,
  getEventsLoadingSelector,
  getEventsSelector,
} from '@/store/organization-event';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
//helpers
import {getEventById, getEventOptions} from './helpers';
import {getErrorMessage} from '@/utils/helpers';
//types
import {SelectOptionsType} from '@/utils/types';
//service
import {orgStorage} from '@/utils/services/storage.service';
//enums
import {STORAGE_KEY} from '@/utils/enums';
//components
import Select from '@/shared/components/Select';
//styles
import {organizationEventSelectStyle} from './OrganizationEventSelect.styles';
import {useGetOrganizationId} from '@/utils/hooks';
import Loader from '@/shared/components/Loader';

const OrganizationEventSelect: FC = () => {
  const dispatch = useAppDispatch();

  const organizationId = useGetOrganizationId();

  const events = useAppSelector(getEventsSelector);
  const currentEvent = useAppSelector(getCurrentEventSelector);
  const isLoading = useAppSelector(getEventsLoadingSelector);

  useEffect(() => {
    if (!organizationId) return;

    const getAllEvents = async () => {
      try {
        await dispatch(getEvents(organizationId)).unwrap();
      } catch (error) {
        toast.error(getErrorMessage(error));
      }
    };

    if (organizationId) getAllEvents();
  }, [organizationId]);

  const eventOptions = useMemo(() => getEventOptions(events) || [], [events]);
  const selectValue = useMemo(() => (currentEvent ? String(currentEvent?.id) : ''), [currentEvent]);

  const handleEventChange = (_: SelectChangeEvent, option: SelectOptionsType) => dispatch(getEvent(option.id));

  return (
    <Box sx={organizationEventSelectStyle.wrapper}>
      {isLoading ? (
        <Loader />
      ) : (
        <Select options={eventOptions} value={selectValue} disabled={!events?.length} onChange={handleEventChange} />
      )}
    </Box>
  );
};

export default OrganizationEventSelect;
